/* eslint-disable max-len */
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/** 11th OVC styled buttons with a slanted icon section.
 *  This component uses content projection to supply the inner text of the button.
 *  Provide the content between the open and close tags. */
@Component({
  selector: 'app-slant-button',
  template: `
  <ng-template #btnContent><ng-content></ng-content></ng-template>
  <button *ngIf="!linkMode; else linkBtn" [type]="submitMode ? 'submit' : 'button'"
   tabindex="0" class="button"
   [disabled]="disabled" [matTooltip]="tooltip" [attr.aria-label]="tooltip"
   [ngStyle]="{'font-weight': fontWeight ? fontWeight : '','font-size': fontSize ? fontSize : ''}"
  [ngClass]="{'button-blue': btnColor === 'blue', 'button-gray': btnColor === 'gray', 'button-green': btnColor === 'green', 'button-yellow': btnColor === 'yellow', 'button-red': btnColor === 'red', 'button-white': btnColor === 'white', 'button-bw': btnColor === 'bw', 'button-outline': outlineMode, 'button-left': leftMode}">
    <i *ngIf="leftMode" [class]="'icon fas ' + btnIconClass" [ngStyle]="{'width': iconWidth ? iconWidth : ''}"></i>
    <span *ngIf="leftMode" [ngClass]="{'button-blue-left': btnColor === 'blue', 'button-gray-left': btnColor === 'gray', 'button-green-left': btnColor === 'green', 'button-yellow-left': btnColor === 'yellow', 'button-red-left': btnColor === 'red', 'button-white-left': btnColor === 'white', 'button-bw-left': btnColor === 'bw', 'chevron': chevronMode}" class="slant"></span>
    <ng-container *ngTemplateOutlet="btnContent"></ng-container>
    <span *ngIf="!leftMode" class="slant" [ngClass]="{'chevron': chevronMode}"></span>
    <i *ngIf="!leftMode" [class]="'icon fas ' + btnIconClass" [ngStyle]="{'width': iconWidth ? iconWidth : ''}"></i>
  </button>
  <ng-template #linkBtn>
    <button class="btn btn-link button-link" [type]="submitMode ? 'submit' : 'button'" tabindex="0" [disabled]="disabled" [matTooltip]="tooltip" [attr.aria-label]="tooltip">
      <i *ngIf="leftMode" [class]="'me-2 fal ' + btnIconClass"></i>
      <ng-container *ngTemplateOutlet="btnContent"></ng-container>
      <i *ngIf="!leftMode" [class]="'ms-2 fal ' + btnIconClass"></i>
    </button>
  </ng-template>
  `,
  styleUrls: ['./slant-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlantButtonComponent {
  /** Show button in Bark's red link style.
   * When using this mode, `btnColor` is ignored. */
  @Input() linkMode = false;
  /** Set to true to disable button presses */
  @Input() disabled = false;
  /** The title attribute when mouseover */
  @Input() tooltip = '';
  /** Set to true to enable outline style button.
   *
   * @default false */
  @Input() outlineMode = false;
  /** Set to blue, gray, white, bw (black & white), green, yellow, or red.
   *
   * @default 'blue'. */
  @Input() btnColor: 'blue' | 'gray' | 'white' | 'bw' | 'green' | 'yellow' | 'red' = 'blue';
  /** The FontAwesome icon class to use.
   *
   * @see https://fontawesome.com/icons?d=gallery for class names.
   * @example 'fa-checkmark' */
  @Input() btnIconClass = '';
  /** If true, aligns the button to the left side. Defaults to false. */
  @Input() leftMode = false;
  /** If true, the slant becomes an angled design. Defaults to false. */
  @Input() chevronMode = false;
  /** If this is true, the button will be rendered in the DOM as a 'submit' type. If false, it will be 'button' type.
   *
   * @default false */
  @Input() submitMode = false;

  @Input() fontWeight;
  @Input() fontSize;
  @Input() iconWidth;
}
